module.exports = __webpack_public_path__ + "static/store-1be8ed9ded1ace61531fd4476dc8d728.png";